import {
  Badge,
  CalendarToday,
  ContactPhone,
  Email,
  Home,
  Info,
  Person,
} from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Typography
} from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import CustomButton from '../../common/button/commonButton';
import { APP_LINK } from '../../common/menu/menuItems/menuList';
import { fetchStaffMember } from '../../redux/staff/staffAction';
  
const ViewStaff = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  
  useEffect(() => {
    dispatch(fetchStaffMember(id));
  }, [dispatch, id]);
  
  const staffState = useSelector((state) => state?.staffs?.fetchStaff || {});

  
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 1:
        return 'success';
      case 0:
        return 'error';
      default:
        return 'default';
    }
  };
  
  // Safely extract staff data
  const staffData = staffState?.data?.data || {};
  const userData = staffData?.User || {};
  const navigateToStaffList = () => {
    navigate(APP_LINK.LISTALLSTAFF);
  }
  return (
    <Box sx={{ maxWidth: "100vw", mx: 'auto', p: 2 }}>
      <Card elevation={3}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h5" component="div">
              <Person sx={{ verticalAlign: 'middle', mr: 1 }} />
              Staff Information
            </Typography>
            <Box sx={{display:'flex' ,gap:2, alignItems:'center'}}>
            <Chip 
              label={userData.status === 1 ? 'Active' : 'Inactive'} 
              color={getStatusColor(userData.status)} 
              icon={<Info />} 
              variant="outlined"
            />
            <CustomButton
              variant="contained"
              color="primary"
              onClick={navigateToStaffList}
            >
              Back
            </CustomButton>
            </Box>
          </Box>
          
          <Divider sx={{ mb: 3 }} />
          
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Person sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Staff Name
              </Typography>
              <Typography variant="body1" gutterBottom>
                {staffData.staff_name || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Badge sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Staff ID
              </Typography>
              <Typography variant="body1" gutterBottom>
                {staffData.staff_id || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Badge sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Staff Serial No
              </Typography>
              <Typography variant="body1" gutterBottom>
                {staffData.staff_serial_no || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Person sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Gender
              </Typography>
              <Typography variant="body1" gutterBottom>
                {staffData.gender_type === 'M' ? 'Male' : 
                 staffData.gender_type === 'F' ? 'Female' : 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Email sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Email
              </Typography>
              <Typography variant="body1" gutterBottom>
                {staffData.email || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <ContactPhone sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Phone Number
              </Typography>
              <Typography variant="body1" gutterBottom>
                {staffData.phone || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Home sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Address
              </Typography>
              <Typography variant="body1" gutterBottom>
                {staffData.address || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Home sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Block ID
              </Typography>
              <Typography variant="body1" gutterBottom>
                {staffData?.Block?.block_name || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Home sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Floor ID
              </Typography>
              <Typography variant="body1" gutterBottom>
                {staffData?.Floor?.floor_name || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Home sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Ward ID
              </Typography>
              <Typography variant="body1" gutterBottom>
                {staffData?.Ward?.ward_name || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Home sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Role ID
              </Typography>
              <Typography variant="body1" gutterBottom>
                {staffData?.Role?.name || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <CalendarToday sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Created At
              </Typography>
              <Typography variant="body1" gutterBottom>
                {formatDate(staffData.createdAt)}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <CalendarToday sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Updated At
              </Typography>
              <Typography variant="body1" gutterBottom>
                {formatDate(staffData.updatedAt)}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};
  
export default ViewStaff;